<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">账号管理</span>
      </div>
      <div class="right">
        <Button type="primary" @click="saveModal(false)">创建账号</Button>
      </div>
    </div>
    <Table :columns="columns" :data="data" :loading="tableLoading" />

    <Modal
      v-model="modal.status"
      :title="modal.data.id ? '编辑角色' : '新增角色'"
      @on-ok="save"
      @on-cancel="modal.status = false"
      width="500"
    >
      <Form
        :model="modal.data"
        :label-width="80"
        :rules="modal.rule"
        ref="formValidate"
      >
        <FormItem label="名称" prop="name">
          <Input v-model="modal.data.name" placeholder="请输入角色名称"></Input>
        </FormItem>

        <FormItem label="登录账号" prop="username">
          <Input
            v-model="modal.data.username"
            placeholder="请输入登录账号"
            :disabled="modal.data.id ? true : false"
            maxlength="11"
            @on-keyup="userNameChange"
            type="number"
          >
            <span slot="prepend">{{ agent.agent_tel || agent.tel }}-</span>
          </Input>
          <p style="color:red">初始密码：123456</p>
        </FormItem>
        <!-- <FormItem label="登录账号" prop="username" v-else>
          <Input
            v-model="modal.data.username"
            placeholder="请输入登录账号"
            disabled
          ></Input>
        </FormItem> -->

        <FormItem label="账户角色" prop="role_id">
          <Select v-model="modal.data.role_id">
            <Option
              v-for="item in modal.role"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="modal.status = false">取消</Button>
        <Button type="primary" @click="save">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      modal: {
        status: false,
        data: {
          id: 0,
          name: '',
          username: '',
          role_id: '',
          status: 0,
          is_del: 0
        },
        role: [],
        rule: {
          name: [
            {
              required: true,
              message: '请输入管理员名称',
              trigger: 'blur'
            }
          ],
          username: [
            {
              required: true,
              message: '请输入登录账号',
              trigger: 'blur'
            }
          ],
          role_id: [
            {
              required: true,
              type: 'number',
              message: '请选择账户角色',
              trigger: 'blur'
            }
          ]
        },
        menu: [],
        values: []
      },
      columns: [
        { title: '管理员名称', key: 'name' },
        { title: '登录账号', key: 'username' },
        { title: '角色', key: 'role_name' },
        {
          title: '操作',
          width: 240,
          key: 'operator',
          render: (h, data) => {
            return [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.saveModal(data.row)
                    }
                  }
                },
                '编辑'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  style: {
                    marginLeft: '10px'
                  },
                  on: {
                    click: () => {
                      this.SaveAdminUser({
                        id: data.row.id,
                        is_set_pass: 1,
                        username: data.row.username
                      }).then((res) => {
                        this.$Message[res.status ? 'success' : 'error'](
                          res.status
                            ? '重置密码成功，初始密码为：123456'
                            : '重置密码失败'
                        )
                        this.getData()
                      })
                    }
                  }
                },
                '重置密码'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  style: {
                    marginLeft: '10px'
                  },
                  on: {
                    click: () => {
                      this.SaveAdminUser({
                        id: data.row.id,
                        status: data.row.status === 1 ? 0 : 1
                      }).then((res) => {
                        this.$Message[res.status ? 'success' : 'error'](
                          res.status ? '操作成功' : '操作失败'
                        )
                        this.getData()
                      })
                    }
                  }
                },
                data.row.status === 1 ? '启用' : '禁用'
              )
            ]
          }
        }
      ],
      tableLoading: false,
      data: []
    }
  },
  mounted () {
    this.initRole()
    this.getData()
  },
  methods: {
    ...mapActions(['GetAdminUser', 'SaveAdminUser', 'GetRole']),
    userNameChange () {
      this.$nextTick(() => {
        if (this.modal.data.username.length > 11) this.modal.data.username = this.modal.data.username.substring(0, 11)
      })
    },
    saveModal (data) {
      this.modal.status = true
      if (data) {
        let arr = data.username.split('-')
        let username = arr[1]
        this.modal.data = {
          id: data.id,
          name: data.name,
          username: username,
          role_id: data.role_id,
          status: data.status,
          is_del: data.is_del
        }
      } else {
        this.modal.data = {
          id: 0,
          name: '',
          username: '',
          role_id: '',
          status: 0,
          is_del: 0
        }
      }
    },
    save () {
      this.$refs['formValidate'].validate((valid) => {
        console.log('this.modal.data', this.modal.data)
        if (valid) {
          let data = {
            name: this.modal.data.name,
            // username: this.modal.data.username,
            username: `${this.agent.agent_tel || this.agent.tel}-${
              this.modal.data.username
            }`,
            role_id: this.modal.data.role_id,
            status: this.modal.data.status,
            is_del: this.modal.data.is_del,
            is_set_pass: 1
          }
          if (this.modal.data.id) data.id = this.modal.data.id
          this.SaveAdminUser(data).then((res) => {
            this.$Message[res.status ? 'success' : 'error'](res.msg)
            if (res.status) {
              this.modal.status = false
              this.getData()
            }
          })
        }
      })
    },
    initRole () {
      this.GetRole({ l: 1000, p: 0 }).then((res) => {
        this.modal.role = res.data
      })
    },
    getData () {
      this.tableLoading = true
      this.GetAdminUser({ l: 1000, p: 0 }).then((res) => {
        this.tableLoading = false
        this.data = res.data
      })
    }
  },
  computed: mapGetters({ agent: 'agent' }),
  watch: {
    'modal.data.username': function (a, b) {
      this.modal.data.username = this.modal.data.username.replace(/[^\d]/g, '')
    },
    deep: true
  }
}
</script>
<style lang='less'>
@import "./index.less";
</style>
